f<style scoped>
a.paginate_button.current {
  background: black !important;
}
input[type="search"] {
  border: 1.5px solid #d8dbe0;
  border-radius: 4px;
  padding: 5px;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background:#1a3665;color:white"
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    > Master Dokumen      
       <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          style="background-color:#486ba7"
          href="#ajuan"
          role="tab"
          aria-controls="home"
          aria-selected="true">Master Dokumen  </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-pendukung"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false">Dokumen Pendukung</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-rekomendasi"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false">Dokumen Rekomendasi</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-asean-cpa"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false">Dokumen Asean CPA</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-anggota-umum"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false">Dokumen Anggota Umum</router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
            @keyup="cariData"
          />
          <br />
        </CCol>

        <CCol lg="12" class="table-responsive mt-3">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #namaDokumen="{item}">
              <td class="py-2 text-left">{{item.namaDokumen ? item.namaDokumen : "-"}}</td>
            </template>
            <template #contohDokumen="{item}">
              <td class="py-2 text-info text-center" style="cursor: pointer">
                <template v-if="role_status && role_status.status_read">
                  <button 
                    :class="item.contohDokumen === null ? 'btn btn-secondary' : 'btn btn-success'" 
                    :disabled="item.contohDokumen === null" 
                    @click="lihatFile(item.contohDokumen)">
                    Lihat File
                  </button>                
                </template>
                <template v-else>
                  <button 
                    class="btn btn-secondary" 
                    :disabled="item.contohDokumen === null" 
                    disable
                  >
                    Lihat File
                  </button>                
                </template>
              </td>
            </template>

            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label for="nama_dokument" class="font-weight-bold">Nama Dokumen</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.formData.namaDokumen.$error,                     
                  }"
                  id="nama_dokumen"
                  placeholder="Masukkan Nama Dokumen"                  
                  v-model="formData.namaDokumen"
                  @input="setNamaDokumen($event.target.value)"
                />                        
              </div>
            </CCol>

            <CCol sm="12 ">
              <label  class="font-weight-bold">
                Unggah File
                <small v-if="actionPost == 'update'">
                  <span @click="lihatFile(formData.contohDokumen)">(Lihat File)</span>
                </small>
              </label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  ref="uploadFileMasterDokumen"
                  @change="fileUpload"                  
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >
                  {{ typeof formData.contohDokumen === "string" ? formData.contohDokumen : fileName }}
                </label>                        
              </div>
              <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import DokumenService from "../../services/datamaster/dokumen.service";
import BaseUrl from "../../services/base-url";
import { AlertUtils } from "../../mixins/AlertUtils"

const fields = [
  { key: "no", _style: "width: 8%" },  
  {
    key: "namaDokumen",
    _style: "text-align: left;"
  },
  {
    key: "contohDokumen",
    _style: "text-align: center;"
  },  
  { key: "aksi", _style: "width:15%; text-align: center" }
];

export default {
  name: "Dokumen",
  mixins : [AlertUtils],
  data() {
    return {
      search: "",
      items: [],
      actionPost: "",
      pageSize: "10",
      formData: {
        namaDokumen: "",
        statusRequired : "",
        kodeDokumen: "",
        contohDokumen: "",
        idMasterDokumen: "",
      },
      pagination: {
        totalPages: 0
      },
      title: "",
      fields,
      fileName: "Pilih File",
      title: "",
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      statusRequired: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout: null,
      awaitingSearch: false,
      role_status: null,
    }
  },
  validations: {
    formData: {
      namaDokumen: { required },
    },
  },
  mounted() {
    
    this.roleData();
    this.baseUrl = BaseUrl();
    this.getData("0", this.pageSize, "default");
    // comment console console.log(this.pageSize);
    document.getElementById("kode_dokumen").onkeypress = function(e) {
      var chr = String.fromCharCode(e.which);
      if ("0123456789-abcdefghijklmnopqrstuvwxyz".indexOf(chr) < 0) return false;
    };
    $(document).on("click", ".browse", function() {
      var file = $(this)
        .parent()
        .parent()
        .parent()
        .find(".file");
      file.trigger("click");
    });
    $(document).on("change", ".file", function() {
      $(this)
        .parent()
        .find(".form-control")
        .val(
          $(this)
            .val()
            .replace(/C:\\fakepath\\/i, "")
        );
    });
  },
  watch: {    
    currentPage: function(val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    },
    myModal: function() {
      if(!this.myModal) {
        this.$v.$reset()
        document.getElementById('nama_dokumen').classList.remove('is-valid')
      }
    }
  },
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    setNamaDokumen(value) {
      this.formData.namaDokumen = value;
      this.$v.formData.namaDokumen.$touch();           
      if(!this.$v.formData.namaDokumen.$error) {
        document.getElementById('nama_dokumen').classList.add('is-valid')
      }
    },
  
    lihatFile(file) {
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=datamaster@masterdokumenpendukung";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
        window.open(
         routeData,
          file,
          params
        );
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },

    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      // clear timeout variable
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function() {
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },

    pageChange() {
      this.getData(currentPage, this.pageSize, this.search);
    }, 

    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            DokumenService.deleteDokumen(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                // this.getData("1");
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError(error.response.data.message);
                // comment console console.log(error.response.data.message);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      // comment console console.log("this function");
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DokumenService.getDokumen(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data);

          // comment console console.log("data parsing table : ", response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;

          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    insertData(formData) {
      // let loader = this.$loading.show({
      //   container: false ? null : this.$refs.formContainer,
      //   canCancel: true,
      //   onCancel: this.onCancel
      // });
      var vm = this;      

      DokumenService.postDokumen(formData).then(
        () => {
          vm.myModal = false;
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              // loader.hide();
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: "success",
            title: "Data Berhasil Ditambah"
          });
          // this.$store.dispatch("request/getInformasiUmum");
          vm.getData("0", "10", "default");
        },
        error => {
          vm.$swal.fire({
            title: "Peringatan!",
            text: error.message,
            icon: "errorr",
            showCancelButton: true
          });
        }
      );
    },

    putData() {
  
      if (typeof this.formData.contohDokumen === "string") {
        delete this.formData.contohDokumen;
      }

      if (this.formData.contohDokumen === null) {
        delete this.formData.contohDokumen;
      }
      var vm = this;
      DokumenService.putDokumen(this.formData)
        .then(response => {
          vm.myModal = false;
          vm.$v.$reset()
          vm.alertEditSuccess();
          vm.getData(0, 10, "default");
        })
        .catch(error => {
          vm.alertError(error.response.data.message);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.formData.contohDokumen = null;
      /**
       * #HANDLING#
       * 
       * Handling Upload File Jika File Yang Di Upload Sama
       */
      this.$refs.uploadFileMasterDokumen.value = null;
      this.fileName = "";
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {      
      this.$v.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);
        }           
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }           
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      if (typeof formData.contohDokumen === "string") {
        delete formData.contohDokumen
      }
      if (formData.contohDokumen === null) {
        delete formData.contohDokumen
      }
      DokumenService.postDokumen(formData)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.$v.$reset()
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error.response.data.message);
          vm.alertError(error.response.data.message);
        });
    },

    fileUpload(e) {      
      this.formData.contohDokumen = e.target.files[0];
      this.fileName = e.target.files[0].name;            
      // comment console console.log(e.target.files);
    },

    closeModal() {
      this.myModal = false;
      this.$v.$reset()
      document.getElementById('nama_dokumen').classList.remove('is-valid')
    }
  }
};
</script>